








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-trash',

})
export default class ITrash extends Vue {

  @Prop({type: [String], default: '#0A0A0A'}) protected color!: string
  @Prop({type: [String], default: '40'}) protected width!: string


  click() {
    this.$emit('clickTrash')
  }
}

